export default __webpack_public_path__ + "static/media/ic_image.5fb30d0c.svg";